export default __webpack_public_path__ + "static/spiritual-india-journey-3-d214aa230023a078f1ac795c61e90d62.jpg";